import { createFileRoute } from '@tanstack/react-router';
import { AdminOrgPage } from '../../features/tenancy';

export const Route = createFileRoute('/admin/orgs/$id')({
  component: function AdminOrgRoute() {
    const { id } = Route.useParams();
    return <AdminOrgPage id={id} />;
  },
});
